var exports = {
  "om": "xa9f3555f--d06ff9--block",
  "dh": "xa9f3555f--d06ff9--stickyBlock",
  "qf": "xa9f3555f--d06ff9--sticky",
  "i7": "xa9f3555f--d06ff9--button_wrap",
};

module.exports = exports;
